const tab_sections = {
    overview: 'Genel Bakış',
    resource_management: 'Kaynak Yönetimi',
    user_management: 'Kullanıcı Yönetimi',
    help_and_support: 'Yardım ve Destek',
};
export default tab_sections;
